var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"badge",class:{
    'is-outline': _vm.outline,
    'is-primary': _vm.primary,
    'is-danger': _vm.danger,
    'is-success': _vm.success,
    'is-warning': _vm.warning,
    'is-muted': _vm.muted,
    'is-strong': _vm.strong,
    'is-small': _vm.small,
    'is-pill': _vm.pill
  },attrs:{"title":_vm.title}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }